export default "__VITE_ASSET__D_jI1HDe__"